import styled from '@emotion/styled';

type DropZoneContainerProps = {
  isActive: boolean;
}

export const DropZoneContainer = styled.div<DropZoneContainerProps>`
  padding: 40px 10px;
  background: #f5f5f5;
  border: 1px ${({ isActive }) => isActive ? 'dashed' : 'solid'} #717171;
  outline: none;
  cursor: pointer;
`;